import Badge, { ColorType } from '@/common/components/Badge'
import { PaymentStatus } from '@/schemas/PaymentStatusSchema'

interface Props {
  value: PaymentStatus
}

function getColor(value: PaymentStatus): ColorType {
  if (value === 'Approved') {
    return 'Positive'
  }

  const declinedStatuses: PaymentStatus[] = [
    'Declined by Applicant',
    'Declined by Admin',
    'Declined by Applicant',
    'Declined by Provider',
    'Refunded by Provider',
    'Declined',
    'Declined by Applicant',
    'Declined by Provider',
    'Refunded by Provider',
    'Appeal Declined by Admin',
  ]

  if (declinedStatuses.includes(value)) {
    return 'Negative'
  }
  const inReviewStatuses: PaymentStatus[] = [
    'In review Admin',
    'In review - LEGACY DO NOT USE',
    'In review Provider',
    'In review Applicant',
    'Appeal awaiting decision',
  ]
  if (inReviewStatuses.includes(value)) {
    return 'Notice'
  }

  return 'Neutral'
}

function PaymentStatusBadge(props: Props) {
  const { value } = props

  function getValue(value: PaymentStatus) {
    if (value === 'In review - LEGACY DO NOT USE') {
      return 'In review'
    }

    return value
  }

  return <Badge semanticColor={getColor(value)}>{getValue(value)}</Badge>
}

export default PaymentStatusBadge
